var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheck02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 11.001"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m0 4.301 1.472-1.49 5.14 5.2 7.916-8.01L16 1.491l-7.916 8.01.013.013-1.472 1.487z",
  "data-name": "Union 69"
})));
export default SvgIconCheck02;